module.exports = __webpack_public_path__ + "static/media/thrust-bearing.a1b779bb.png";